module.exports = __webpack_public_path__ + "static/card3-48b2eec27233047f6aec7c0b96a1be86.jpg";